module.exports = __webpack_public_path__ + "static/media/ic_warning_remove.bebe12f8.svg";